import { BASE_COLORS, BORDER_RADIUS, FONT_WEIGHT } from '@app/style/constants';
import styled from 'styled-components';

export const AuthWrap = styled.div`
    background-color: var(--white);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.33);
    border-radius: ${BORDER_RADIUS};
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-height: 95vh;
    overflow-y: auto;
    width: 100%;

    h3,
    h4 {
        font-weight: ${FONT_WEIGHT.medium};
    }

    a {
        color: ${BASE_COLORS.green};
        text-decoration: underline;
    }

    .ant-flex-wrap-wrap > .ant-form-item {
        flex-basis: calc(50% - 4px);
    }
`;

// TODO: Delete once remove all usages.
export const AuthFormWrap = styled.div`
	.ant-form-item-label label {
		height: 20px !important;
	}
`;
